import { ReactNodeViewRenderer, Node, mergeAttributes } from '@tiptap/react'
import { Component } from './component'

export interface ShareButtonsNodeAttrs {
	/**
	 * The identifier for the selected variable.
	 */
	id: string | null
}

export type ShareButtonsOptions = {
	/**
	 * How many you jump by inviting one.
	 * @default wt.ls/url/hjwq7hx
	 * @example { referralLink: 'wt.ls/url/hjwq7hx' }
	 */
	referralLink: string
}

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		shareButtons: {
			setShareButtons: () => ReturnType
		}
	}
}

export const ShareButtons = Node.create<ShareButtonsOptions>({
	name: 'share-buttons',

	addOptions() {
		return {
			referralLink: 'wt.ls/url/hjwq7hx',
		}
	},

	addAttributes() {
		return {
			id: null,
		}
	},

	isolating: true,

	allowGapCursor: false,

	content: 'block*',

	defining: true,

	group: 'block',

	draggable: true,

	selectable: true,

	parseHTML() {
		return [
			{
				tag: 'share-buttons',
			},
		]
	},

	renderHTML({ HTMLAttributes }) {
		return ['share-buttons', mergeAttributes(HTMLAttributes), 0]
	},

	addCommands() {
		return {}
	},

	addNodeView() {
		return ReactNodeViewRenderer(Component)
	},
})

export default ShareButtons
